import { render, staticRenderFns } from "./rankWarning.vue?vue&type=template&id=31ba0f60&scoped=true&"
import script from "./rankWarning.vue?vue&type=script&lang=js&"
export * from "./rankWarning.vue?vue&type=script&lang=js&"
import style0 from "./rankWarning.vue?vue&type=style&index=0&id=31ba0f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba0f60",
  null
  
)

export default component.exports